<template>
    <Container>
        <div class="container-content">
            <slot></slot>
        </div>
    </Container>
</template>

<script setup>
</script>

<style lang="scss">
@use "./index.scss";
</style>
